import React from "react";
import { Typography, IconButton, Tooltip, Stack, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getRuta } from "../../../helpers/Helpers";

import PriceCheckRoundedIcon from "@mui/icons-material/PriceCheckRounded";
const OtrosIngresos = ({ value }) => {
  let ruta = getRuta();

  let navigate = useNavigate();
  return (
    <div>
      <Stack
        direction={"row"}
        style={{ padding: 10 }}
        justifyContent="space-between"
        alignItems={"center"}
      >
        <Tooltip title="Ver Otros Ingresos">
          <IconButton
            sx={{ border: 1, borderColor: "rgba(0, 255, 0, 1)" }}
            style={{
              width: 100,
              height: 100,
              backgroundColor: "rgba(0, 255, 0, 0.2)",
            }}
            onClick={() => navigate(`${ruta}/dash-otrosIngresos`)}
          >
            <PriceCheckRoundedIcon
              style={{
                fontSize: 110,
                color: "rgba(0, 255, 0, 1)",
                opacity: 0.3,
                padding: 10,
              }}
            />
          </IconButton>
        </Tooltip>
        <Stack>
          <Typography
            align="right"
            style={{
              color: "rgba(0, 255, 0, 1)",
              fontWeight: 800,
              fontSize: 20,
            }}
            paragraph
          >
            {new Intl.NumberFormat("es-NI", {
              style: "currency",
              currency: "NIO",
            }).format(value)}
          </Typography>
        </Stack>
      </Stack>
      <Divider />
      <Typography
        variant="subtitle1"
        align="center"
        style={{ color: "rgba(0, 255, 0, 1)", fontSize: 20 }}
      >
        Otros Ingresos
      </Typography>
    </div>
  );
};

export default OtrosIngresos;
